export const mapTransmission = (transmission) => {
    switch (transmission.toUpperCase()) {
        case 'MANUAL':
            return 'Manuale';
        case 'AUTOMATIC':
            return 'Automatico';
        default:
            return 'Altro';
    }
}